export default {
    // @URLエンコードとパラメータ
    'URLエンコード': {
        type: 'func',
        josi: [['を', 'から']],
        pure: true,
        fn: function (text) {
            return encodeURIComponent(text);
        }
    },
    'URLデコード': {
        type: 'func',
        josi: [['を', 'へ', 'に']],
        pure: true,
        fn: function (text) {
            return decodeURIComponent(text);
        }
    },
    'URLパラメータ解析': {
        type: 'func',
        josi: [['を', 'の', 'から']],
        pure: true,
        fn: function (url, sys) {
            const res = {};
            if (typeof url !== 'string') {
                return res;
            }
            const p = url.split('?');
            if (p.length <= 1) {
                return res;
            }
            const params = p[1].split('&');
            for (const line of params) {
                if (line === '') {
                    continue;
                }
                const eqIdx = line.indexOf('=');
                let k;
                let v;
                if (eqIdx < 0) {
                    k = line;
                    v = '';
                }
                else {
                    k = line.substring(0, eqIdx);
                    v = line.substring(eqIdx + 1);
                }
                const decodedKey = sys.__exec('URLデコード', [k]);
                const decodedVal = sys.__exec('URLデコード', [v]);
                res[decodedKey] = decodedVal;
            }
            return res;
        }
    },
    // @BASE64
    'BASE64エンコード': {
        type: 'func',
        josi: [['を', 'から']],
        pure: true,
        fn: function (text) {
            // browser?
            if (typeof (window) !== 'undefined' && window.btoa) {
                const u8a = new TextEncoder().encode(text);
                const utf8str = String.fromCharCode.apply(null, u8a);
                return btoa(utf8str);
            }
            // Node?
            if (typeof (Buffer) !== 'undefined') {
                return Buffer.from(text).toString('base64');
            }
            throw new Error('『BASE64エンコード』は利用できません。');
        }
    },
    'BASE64デコード': {
        type: 'func',
        josi: [['を', 'へ', 'に']],
        pure: true,
        fn: function (text) {
            if (typeof (window) !== 'undefined' && window.atob) {
                const decodedUtf8str = atob(text);
                const dec = Array.prototype.map.call(decodedUtf8str, c => c.charCodeAt());
                const decodedArray = new Uint8Array(dec);
                return new TextDecoder('UTF-8').decode(decodedArray);
            }
            // Node?
            if (typeof (Buffer) !== 'undefined') {
                return Buffer.from(text, 'base64').toString();
            }
            throw new Error('『BASE64デコード』は利用できません。');
        }
    },
    // @パス操作
    '拡張子抽出': {
        type: 'func',
        josi: [['から', 'の']],
        pure: true,
        fn: function (fname, sys) {
            if (fname === null || fname === undefined) {
                return '';
            }
            const sep = sys.pathSeparator || '/';
            if (fname.indexOf(sep) >= 0) { // パス記号があればファイル名を抽出
                const parts = fname.split(sep);
                fname = parts[parts.length - 1];
            }
            const m = fname.match(/(\.[a-zA-Z0-9_\-+]+)$/);
            if (m) {
                return m[1];
            }
            return '';
        }
    },
    '拡張子変更': {
        type: 'func',
        josi: [['の', 'を', 'から'], ['に', 'へ']],
        pure: true,
        fn: function (fname, ext, sys) {
            if (fname === null || fname === undefined) {
                return ext;
            }
            const sep = sys.pathSeparator || '/';
            const pathList = fname.split(sep);
            const filename = pathList[pathList.length - 1];
            const pathStr = pathList.slice(0, -1).join(sep);
            const rawExt = (ext ?? '').trim();
            let extWithDot = rawExt;
            if (rawExt !== '') {
                extWithDot = rawExt.startsWith('.') ? rawExt : '.' + rawExt;
            }
            const newFilename = filename.replace(/(\.[a-zA-Z0-9_\-+]+)?$/, extWithDot);
            return sys.__exec('終端パス追加', [pathStr, sys]) + newFilename;
        }
    },
    '終端パス追加': {
        type: 'func',
        josi: [['に', 'へ']],
        pure: true,
        fn: function (path, sys) {
            const sep = sys.pathSeparator || '/';
            if (path === undefined || path === null || path === '') {
                return '';
            }
            if (path.endsWith(sep)) {
                return path;
            }
            return path + sep;
        }
    },
    '終端パス除去': {
        type: 'func',
        josi: [['の', 'から']],
        pure: true,
        fn: function (dir, sys) {
            const sep = sys.pathSeparator || '/';
            if (!dir) {
                return '';
            }
            if (dir.endsWith(sep)) {
                return dir.substring(0, dir.length - 1);
            }
            else {
                return dir;
            }
        }
    },
    '終端パス削除': {
        type: 'func',
        josi: [['の', 'から']],
        pure: true,
        fn: function (dir, sys) {
            return sys.__exec('終端パス除去', [dir, sys]);
        }
    },
    'ファイル名抽出': {
        type: 'func',
        josi: [['の', 'から']],
        pure: true,
        fn: function (dir, sys) {
            const sep = sys.pathSeparator || '/';
            const parts = dir.split(sep);
            return parts[parts.length - 1];
        }
    },
    'パス抽出': {
        type: 'func',
        josi: [['の', 'から']],
        pure: true,
        fn: function (dir, sys) {
            const sep = sys.pathSeparator || '/';
            const parts = dir.split(sep);
            parts.pop();
            return parts.join(sep);
        }
    }
};
